import React from 'react';
import { Button } from './button';
import { DollarSign, TrendingUp, Shield } from 'lucide-react';

export const InvestmentSection = ({ onApplyClick }) => {
  const highlights = [
    {
      icon: DollarSign,
      title: "Competitive Investment",
      description: "Affordable initial investment with flexible financing options"
    },
    {
      icon: TrendingUp,
      title: "Strong ROI Potential",
      description: "Proven business model with excellent return potential"
    },
    {
      icon: Shield,
      title: "Low Risk Investment",
      description: "Comprehensive support reduces business risks significantly"
    }
  ];

  return (
    <section id="investment" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="section-title text-5xl md:text-6xl font-bold mb-6 text-dark">
            Franchise Investment Details
          </h2>
          <p className="text-xl text-subtle max-w-3xl mx-auto">
            A low-risk, supported investment opportunity with strong returns and comprehensive business support
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {highlights.map((highlight, index) => (
            <div key={index} className="investment-highlight text-center group">
              <div className="w-20 h-20 bg-accent-light rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-accent-primary group-hover:scale-110 transition-all duration-300">
                <highlight.icon className="w-10 h-10 text-accent-primary group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-dark">{highlight.title}</h3>
              <p className="text-subtle">{highlight.description}</p>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <div className="bg-cream rounded-3xl p-12 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-6 text-dark">Ready to Learn More?</h3>
            <p className="text-lg text-subtle mb-8">
              Not sure if franchising is the right path for you? Take our quick assessment 
              to discover if you have what it takes to run a successful hair extensions franchise.
            </p>
            <a 
              href="https://www.qualiquiz.app/quiz/salon-franchise-candidate-pre-qualification-asses"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block border-2 border-accent-primary text-accent-primary hover:bg-accent-primary hover:text-white transition-all duration-300 px-8 py-3 rounded-full text-lg font-semibold"
            >
              Find Out If Franchising Is Right For You - Take 60 Second Quiz
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};